import { Request } from '@/classes/Request'
import type { AthleticsMessageSent } from '@/types/enrollments'
import { normalizeAthleticsConversation } from '@/modules/api/get/athleticsMessagesInbox'
import { normalizeAthleticsMessage } from '@/modules/api/get/athleticsConversationMessages'

const sent = (data: any): AthleticsMessageSent => ({
  conversation: data?.conversation ? normalizeAthleticsConversation(data.conversation) : null,
  message: data?.message ? normalizeAthleticsMessage(data.message) : null
})

// POST /ajax/athletics/{enrollmentId}/messages {body, quoted_announcement_id?}
// (DTA-799 round 11): find-or-create the private thread for this
// registration's student on the team and append. Used to start a thread and
// for "Reply privately" from an announcement.
export const athleticsStudentMessage = async (
  enrollmentId: number,
  body: string,
  quotedAnnouncementId: string | null = null
): Promise<AthleticsMessageSent> => {
  const payload: Record<string, any> = { body }
  if (quotedAnnouncementId) payload.quoted_announcement_id = quotedAnnouncementId
  const response = await new Request(undefined, 'json', { redirectOnForbidden: false }).post(
    '/ajax/athletics/' + enrollmentId + '/messages',
    payload
  )
  return sent(response.data)
}

// POST /ajax/athletics/conversations/{id}/messages {body}: append to the
// family's own thread (403 on announcements).
export const athleticsConversationMessage = async (
  conversationId: string,
  body: string
): Promise<AthleticsMessageSent> => {
  const response = await new Request(undefined, 'json', { redirectOnForbidden: false }).post(
    '/ajax/athletics/conversations/' + encodeURIComponent(conversationId) + '/messages',
    { body }
  )
  return sent(response.data)
}
